import { ColumnDef } from '@tanstack/react-table';

const getColumnDefId = <RowData>(columnDef: ColumnDef<RowData, any>): string | undefined => {
    if (columnDef.id) return columnDef.id;
    if ('accessorKey' in columnDef && columnDef.accessorKey) return String(columnDef.accessorKey).replace(/\./g, '_');
    return typeof columnDef.header === 'string' ? columnDef.header : undefined;
};

export const getColumnDefIds = <RowData>(columnDefs: ColumnDef<RowData, any>[]): string[] =>
    columnDefs.flatMap((columnDef) => {
        if ('columns' in columnDef && columnDef.columns) return getColumnDefIds(columnDef.columns);

        const id = getColumnDefId(columnDef);
        return id ? [id] : [];
    });
